const html = require("./html/asnDetailRowView.html");
import {setElementsFromScope, insertValAndManageFocus, show, hide, handleDisplayFor, setCheckboxState, setRequired, setUniqNamesAndIds, setDisabled} from "../../../utilities/selectorHelpers";
import render from "../../../utilities/render";
import _ from "underscore";
import $ from "jquery";
import AsnStore from "../../../stores/AsnStore";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import ProductItemStore from "../../../stores/ProductItemStore";
import {isPresent} from '../../../utilities/general';
// product shape:

//   {
//     id: 1,
//     unitsPerCase: 1,
//     caseLineNumber: 1
//   }

const elementsMap = {
  asnDetailLength: ".asn-detail-length",
  asnDetailWidth: ".asn-detail-width",
  asnDetailHeight: ".asn-detail-height",
  asnDetailWeight: ".asn-detail-weight",
  palletCaseIdx: ".pallet-case-idx",
  palletCaseLabel: ".pallet-case-label",
  stackablePalletOuter: ".stackable-pallet-outer",
  stackablePalletCheckbox: ".stackable-pallet-checkbox",
  shippingTabSkus: ".shipping-tab-prd-skus",
  prdLevelPalletCaseLabel: ".prd-level-pallet-case-label",
  palletCaseNumber : ".pallet-case-number",
  applyDimensionWeightOuter : ".apply-dimension-weight-to-all-outer",
  applyDimensionToAllBtn : ".apply-to-all-btn",
  declaredValueInput: ".declared-value-input",
  useCalculatedVal: ".use-calculated-val",
  dvlInsideCase: ".dvl-inside-case"
};

      
export default function AsnDetailRow(asnDetail,options){
  const asnDetailId = asnDetail.id;

  const {rowIdx, isPallet, readOnly, onAsnDetailGroupFieldChange,getAsnDetailGroups} = options;

  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    renderInit();
  };

  function bindElements(){
    bindApplyDimensionAndWeight();
    els.asnDetailLength.on("input", handleAsnDetailGroupFieldChange("asd_package_length"));
    els.asnDetailWidth.on("input", handleAsnDetailGroupFieldChange("asd_package_width"));
    els.asnDetailHeight.on("input", handleAsnDetailGroupFieldChange("asd_package_height"));
    els.asnDetailWeight.on("input", handleAsnDetailGroupFieldChange("asd_package_weight"));
    els.declaredValueInput.on("input", handleDeclaredValueInput);
    els.stackablePalletCheckbox.on("click", handleAsnFieldCheckboxChange("stackablePallet"));
    els.useCalculatedVal.on("click", handleUseCalculatedVal);
    els.dvlInsideCase.on("click", handleDvlInsideCaseChange);    
  }

  function handleDeclaredValueInput() {
    let val = $(this).val();
    if(_.isNumber(val)){
      val = parseInt(val, 10);
    }
    if(val > 50000) {
      val = 50000;
    }
    els.declaredValueInput.val(val);
    onAsnDetailGroupFieldChange(rowIdx, "declaredValue", val);
    onAsnDetailGroupFieldChange(rowIdx, "declaredValueCustomVal", val);
  }

  function handleUseCalculatedVal() {
    const asnDetail = getAsnDetail();
    if($(this).is(":checked")) {
      els.declaredValueInput.val(asnDetail.dvlCalculatedValue);
      els.declaredValueInput.prop('readonly', true);
    } else {
      els.declaredValueInput.val(asnDetail.declaredValueCustomVal);
      els.declaredValueInput.prop('readonly', false);
    }
    onAsnDetailGroupFieldChange(rowIdx, "useCalculatedVal", !!$(this).is(":checked"));
    onAsnDetailGroupFieldChange(rowIdx, "declaredValue", els.declaredValueInput.val());
  }

  function handleDvlInsideCaseChange() {
    const asnDetails = getAsnDetail();
    const dvl = $(els.declaredValueInput).val();
    const dvlflag = $(this).is(":checked");
    if(dvlflag === true && !isPresent(dvl)) {
      $(els.declaredValueInput).val(asnDetails.dvlCalculatedValue);
    }
    onAsnDetailGroupFieldChange(rowIdx, "dvlInsideCase", !!$(this).is(":checked"));
  }

  function handleAsnFieldCheckboxChange(key){
    return function(e) {
      onAsnDetailGroupFieldChange(rowIdx, key, !!$(this).is(":checked"));
    };
  }

  function handleAsnDetailGroupFieldChange(key){
    return function(e) {
      let val = $(this).val();
      // only parseInt if it's a number,
      // otherwise this field will end up
      // as a NaN
      if(_.isNumber(val)){
        val = parseInt(val, 10);
      }
      onAsnDetailGroupFieldChange(rowIdx, key, val);
      // options[funcName](rowIdx, val);
    };
  }

  function bindStores(){
    AsnDetailStore.bindListener(`asn_details:change`, updateSelf);
    AsnDetailStore.bindListener(`asn_details:change`, updateChildren);
    AsnDetailStore.bindListener(`asn_details:change`, updateChildren);
    AsnStore.bindListener(`asns:dvl-inside-case`, updateDvl);
  }

  self.unbindListeners = function(){
    AsnDetailStore.unbindListener(`asn_details:change`, updateSelf);
    AsnDetailStore.unbindListener(`asn_details:change`, updateChildren);
    AsnDetailStore.bindListener(`asn_details:change`, updateChildren);
    AsnStore.unbindListener(`asns:dvl-inside-case`, updateDvl);
  };

  function updateDvl(){
    const asn = getAsn(asnDetail.asnId);
    setCheckboxState(els.dvlInsideCase, asn.applyDvl);
    els.dvlInsideCase.trigger('change');
    onAsnDetailGroupFieldChange(rowIdx, "dvlInsideCase", asn.applyDvl);
    setCheckboxState(els.useCalculatedVal, true);
    els.useCalculatedVal.trigger('change');
    onAsnDetailGroupFieldChange(rowIdx, "useCalculatedVal", true);
    els.declaredValueInput.prop('readonly', true);
    onAsnDetailGroupFieldChange(rowIdx, "declaredValue", els.declaredValueInput.val());
  }

  function setWidgets(){
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    // handle rendering children
    updateSelf();
    updateChildren();
  }

  function updateSelf(){
    // handle updating values;
    updateValues();
    updatePalletCaseIdx();
    updatePalletCaseLabel();
    updatePalletSpecificFields();
    updateNumberOfCasePallet();
    setApplyDimensionWeightBtn();
  }

  function updateChildren(){
    updateProductList();
  }

  function setApplyDimensionWeightBtn(){
   if(rowIdx == 0)
   {
    show(els.applyDimensionWeightOuter);
   }
   else
   {
     hide(els.applyDimensionWeightOuter);
   }
  }

  function getAsnDetailGroup(){
    return getAsnDetailGroups()[rowIdx];
  }

  function updateNumberOfCasePallet(){
    $.each(getAsnDetailGroup(),function(index,object){
       if(isPallet()){
         $(els.palletCaseNumber).html(object.numberOfPallets);
       }else
       {
         $(els.palletCaseNumber).html(object.numberOfCases);
       }
    });
  }

  function updatePalletSpecificFields(){
    handleDisplayFor(els.stackablePalletOuter, isPallet());
  }

  function updateValues(){
    const asnDetail = getAsnDetail();
    if(asnDetail) {
      insertValAndManageFocus(els.asnDetailLength, asnDetail.asd_package_length);
      insertValAndManageFocus(els.asnDetailWidth, asnDetail.asd_package_width);
      insertValAndManageFocus(els.asnDetailHeight, asnDetail.asd_package_height);
      insertValAndManageFocus(els.asnDetailWeight, asnDetail.asd_package_weight);
      setCheckboxState(els.stackablePalletCheckbox, asnDetail.stackablePallet);
      if(isPresent(asnDetail.dvlInsideCase)) {
        setCheckboxState(els.dvlInsideCase, asnDetail.dvlInsideCase);
        els.dvlInsideCase.trigger('change');
      }
      if(isPresent(asnDetail.useCalculatedVal)) {
        setCheckboxState(els.useCalculatedVal, asnDetail.useCalculatedVal);
        if(els.useCalculatedVal.is(":checked")) {
          insertValAndManageFocus(els.declaredValueInput, asnDetail.dvlCalculatedValue);
          els.declaredValueInput.prop('readonly', true);
        } else {
          const newVal = asnDetail.declaredValueCustomVal || asnDetail.declaredValue;
          insertValAndManageFocus(els.declaredValueInput, newVal);
          els.declaredValueInput.prop('readonly', false);
        }
      }

    }
  }

  //Need to revist this piece with _map.
  function updateProductList(){
   var productListHtml = "";
   //let declaredCost = 0;
   $.each(getAsnDetailGroup(),function(index,object){
      let palletCaseNumber = 0;
      if(isPallet()){
         palletCaseNumber = object.numberOfPallets;
       }else{
         palletCaseNumber = object.numberOfCases;
       }

      let item = ProductItemStore.getDataViaAsnDetail(object);
      if(item.length >0) {
        productListHtml += "<div class='row'> <div class='col-md-3 col-xs-12'><span class='q-tag'>"+object.sku+"</span></div><div class='col-md-6 col-xs-12'>"+item[0].prdName+"</div><div class='col-md-3 col-xs-12'>Quantity Packed:"+ object.unitsPerCase +"</div></div>";              
        //declaredCost = object.declaredValue;
      }
      
   });

  	$(els.shippingTabSkus).html(productListHtml);
    //$(els.declaredValueInput).val(declaredCost);
  }

  function updatePalletCaseIdx(){
    els.palletCaseIdx.text(rowIdx + 1);
  }

  function updatePalletCaseLabel(){
    let text = "Case";
    if(isPallet()){
      text = "Pallet";
    }
    els.palletCaseLabel.text(text);
    $(els.prdLevelPalletCaseLabel).html(text);
  }

  function defaultToOne(numb){
    return (numb || 1);
  }

  function renderInit(){
    const asnDetail = getAsnDetail();
    let startDvlInsideCaseStyle = "display:none;";
    let calculatedValueNoteCaseStyle = "";
    
    if(asnDetail && asnDetail.dvlInsideCase){
      startDvlInsideCaseStyle = "";
      if(asnDetail.useCalculatedVal){
        calculatedValueNoteCaseStyle= "display:none;";
      }
    }
    self._element = $(render(html, {
      isPallet:isPallet(),
      startDvlInsideCaseStyle,
      calculatedValueNoteCaseStyle
    }));
    setElements();
    setUniqueIdForStackble();
    setUniqNamesAndIds([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
    setRequired([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
    handleReadOnly();
    setWidgets();
    bindElements();
    bindStores();
    update();
  }

  function setUniqueIdForStackble(){
    const checkBox = self._element.find(".stackable-pallet-checkbox-container");
    checkBox.find("input").attr("id","shipping-pallet-stackable"+rowIdx);
    checkBox.find("input").attr("name","shipping-pallet-stackable"+rowIdx);
    checkBox.find("label").attr("for","shipping-pallet-stackable"+rowIdx);
  }

  function handleReadOnly(){
    if(readOnly){
      setDisabled([
        els.asnDetailWidth, 
        els.asnDetailLength, 
        els.asnDetailHeight, 
        els.asnDetailWeight,
        els.stackablePalletCheckbox
      ]);
    }
  }

  function getAsnDetail(){
    return AsnDetailStore.getAsnDetail(asnDetailId);
  }

  function getAsn(id){
    return AsnStore.getAsn(id);
  }
 
  function bindApplyDimensionAndWeight(){
    $(els.applyDimensionToAllBtn).on("click", function(e){
      AsnDetailStore.copyDimensionsToAllCasesForSameAsn(asnDetailId);
     });
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/AsnDetailRowView.js